import React, { useEffect, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { Button, Col, Divider, Dropdown, Icon, Input, Menu, message, Modal, Row, Table, Typography, Upload, Select } from "antd";
import { ReactComponent as StoreLogo } from "./Store.svg";
import Loader from "components/Loader/Loader";

import "./Stores.css";
// .ant-upload.ant-upload-select-picture-card {
//   display: none;
// }
import { updateStoreApi, fetchAllStoresApi, AddStoreApi, getAddress, getLanguagesApi, AddStoreDetailApi } from "utils/apiService";
import { countries } from "constants/CountryList";
import { handelChange } from "actions/channelProduct";
import StoresTable, { getCountryFlag } from "./StoresTable";

const { Text } = Typography;
const { Dragger } = Upload;
const { Option } = Select;

const formValidation = (storeDetails, storeMainDetails, StoreImageFile) => {
	const { name, store_details } = storeDetails;
	let isNumber = /[+-]?([0-9]*[.])?[0-9]+/;
	for (var details of Object.keys(storeMainDetails)) {
		if (storeMainDetails[details] == "" && details !== 'uuid') {
			message.error(`${details} is required`);
			return false;
		}
	}
	for (var lang of Object.keys(storeDetails.store_details)) {
		for (var key of Object.keys(storeDetails.store_details[lang])) {
			if (storeDetails?.store_details[lang][key] == "") {
				message.error(`${lang} ${key} is required`);
				return false;
			}
			for (var location of Object.keys(storeDetails?.store_details[lang].location)) {
				if (storeDetails?.store_details[lang].location[location] == "") {
					message.error(`${lang} ${location} is required`);
					return false;
				}
			}
		}
	}
	if (name === "") {
		message.error(`Store Name is required`);
		return false;
	}
	if (StoreImageFile === null) {
		message.error(`Store Image is required`);
		return false;
	}
	if (isNumber.test(store_details["English"]?.location?.longitude) === false) {
		message.error(`Longitute must be number`);
		return false;
	}
	if (isNumber.test(store_details["English"]?.location?.latitude) === false) {
		message.error(`Latitude must be number`);
		return false;
	}
	return true;
};
const addStore = async (setStoreDeatils, storeDetails, storelocation, StoreImageFile, setaddModal, loadTable, storeMainDetails, setDisableButton) => {
	// console.log(storeDetails);
	if (!formValidation(storeDetails, storeMainDetails, StoreImageFile)) {
		return;
	}
	setDisableButton(true)
	// setStoreDeatils({
	// 	...storelocation,
	// 	location: JSON.stringify(storelocation),
	// });
	const body = new FormData();
	// debugger;
	for (var key of Object.keys(storeMainDetails)) {
		body.append(key, storeMainDetails[key]);
	}
	body.append("image", StoreImageFile);
	body.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));
	AddStoreApi({
		requestData: body,
		resCallback: () => { },
		res200Callback: (res) => {
			AddStoreDetailApi({
				requestData: {
					...storeDetails,
					["uuid"]: res.data.uuid,
				},
				resCallback: () => { },
				res200Callback: () => {
					message.success("Store added successfully.");
					loadTable();
					setaddModal(false);
					setDisableButton(false)
					// return
				},
				resErrorCallback: () => {
					message.error("Failed adding the store details!");
				},
			});
			// return
		},
		resErrorCallback: () => {
			message.error("Failed adding the store !");
		},
	});
};

const StoresList = (props) => {
	let { path } = useRouteMatch();
	const [disableButton, setDisableButton] = useState(false);
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(true);
	const [addModal, setaddModal] = useState(false);
	const [activeTab, setActiveTab] = useState("active");

	const [searchKey, setSearchKey] = useState("");
	const [StoreImageFile, setStoreImageFile] = useState(null);

	const [languagesData, setLanguagesData] = useState([]);

	const [storelocation, setStorelocation] = useState({
		latitude: "",
		longitude: "",
		region: "",
		city: "",
		country: "",
		address: "",
	});

	const [selectedLanguage, setSelectedLanguage] = useState("English")
	const [storeDetails, setStoreDeatils] = useState({
		// name: "",
		// location: "",
		// company_code: "",
		// sap_code: "",
		// language: "",
		uuid: "",
		store_details: "",
	});
	const [storeDetailsObject, setStoreDetailsObject] = useState({
		name: "",
		location: "",
	});
	const [storeMainDetails, setStoreMainDeatils] = useState({
		// uuid: "",
		company_code: "",
		sap_code: "",
		// language: "",
	});
	const [storeList, setstoreList] = useState({
		stores: [],
		pageNum: 1,
		pageSize: 10,
		totalPages: 1,
	});
	const [StoresCounts, setStoresCounts] = useState({
		active: 0,
		disable: 0,
	});

	const getStoresList = (StoresList, ActiveTab) => {
		if (ActiveTab === "active")
			StoresList = StoresList.filter((data) => {
				return data.is_enabled === true || data.is_enabled === undefined;
			});

		else if (ActiveTab === "disable")
			StoresList = StoresList.filter((data) => {
				return data.is_enabled === false;
			});
		else {
			languagesData.map((value) => {
				if (ActiveTab === value)
					StoresList = StoresList.filter((data) => {
						return data.language === ActiveTab;
					});
			})
		}
		// console.log(StoresList);
		return StoresList;
	};
	const loadTable = (searchKey) => {
		fetchAllStoresApi({
			requestData: {
				// page: storeList.pageNum,
				// status: activeTab === "active" ? "active" : "archived",
			},
			resCallback: () => {
				// loading && setLoading(false);
				setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				// console.log(JSON.stringify(res.data));
				// console.log(searchKey);
				var store_list =
					searchKey === "" || !searchKey
						? res.data.store_list
						: res.data.store_list?.filter((store) => {
							return (
								store.name?.toLowerCase().replaceAll(" ", "").includes(searchKey.toLowerCase().replaceAll(" ", "")) ||
								store.sap_code?.toLowerCase().replaceAll(" ", "").includes(searchKey.toLowerCase().replaceAll(" ", "")) ||
								store.company_code?.toLowerCase().replaceAll(" ", "").includes(searchKey.toLowerCase().replaceAll(" ", "")) ||
								store.location?.address?.toLowerCase().replaceAll(" ", "").includes(searchKey.toLowerCase().replaceAll(" ", ""))
							);
						});
				// store_list && store_list.reverse();
				// debugger;
				setstoreList({
					...storeList,
					stores: getStoresList(store_list, activeTab),
					totalPages: res.data.total_pages,
				});
				setStoresCounts({
					active: getStoresList(store_list, "active").length,
					disable: getStoresList(store_list, "disable").length,
				});
				// console.log(storeList);
			},
		});
		// fetchCohortCountApi({
		//   requestData: {},
		//   resCallback: () => {
		//     loading && setLoading(false);
		//   },
		//   res200Callback: (res) => {
		//     setStoresCounts({
		//       archived: res.data.archived,
		//       active: res.data.active,
		//     });
		//   },
		// });
	};

	useEffect(() => {
		loadTable();
	}, [activeTab]);

	useEffect(() => {


		getLanguagesApi({
			requestData: {

			},
			res200Callback: (res) => {
				setLanguagesData(res.data.languages);
			},
		});
	}, []);


	const fetchAddress = () => {
		storelocation.latitude &&
			storelocation.longitude &&
			getAddress(storelocation.latitude, storelocation.longitude).then((address) => {
				setStorelocation({
					...storelocation,
					["region"]: address.state || address.country || "",
					["city"]: address.city || storelocation.city,
					["country"]: address.countryName || storelocation.country,
				});
			});
	}

	const setLanguageSpecificStoreInfo = (key, value) => {
		let storeSubDeatils = {
			...storeDetails?.store_details[selectedLanguage],
			[key]: value,
		}
		let languageSpecificStoreDetails = {
			...storeDetails?.store_details,
			[selectedLanguage]: {
				...storeSubDeatils
			}
		}
		setStoreDeatils({
			...storeDetails,
			["store_details"]: languageSpecificStoreDetails
		});
	}

	const setLanguageSpecificStoreLocation = (key, value) => {
		let storeLocationObj = {
			...storeDetails?.store_details[selectedLanguage]?.location,
			[key]: value,
		}
		let storeSubDeatils = {
			...storeDetails?.store_details[selectedLanguage],
			["location"]: storeLocationObj,
		}
		let languageSpecificStoreDetails = {
			...storeDetails?.store_details,
			[selectedLanguage]: {
				...storeSubDeatils
			}
		}
		setStoreDeatils({
			...storeDetails,
			["store_details"]: languageSpecificStoreDetails
		});
	}

	const getlocation = (locObj) => {
		// storelocation.latitude &&
		// 	storelocation.longitude &&
		locObj.latitude &&
			locObj.longitude &&
			getAddress(locObj.latitude, locObj.longitude).then((address) => {
				// setStorelocation({
				// 	...storelocation,
				// 	["region"]: address.state || address.country || "",
				// 	["city"]: address.city || storelocation.city,
				// 	["country"]: address.countryName || storelocation.country,
				// });
				let loc = {
					...locObj,
					["region"]: address.state || address.county || "",
					["city"]: address.city || storeDetails?.store_details[selectedLanguage]?.location?.city,
					["country"]: address.countryName || locObj.country,
				}
				setLanguageSpecificStoreInfo("location", loc)
			});
	}

	// useEffect(() => {
	// 	storelocation.latitude &&
	// 		storelocation.longitude &&
	// 		getAddress(storelocation.latitude, storelocation.longitude).then((address) => {
	// 			setStorelocation({
	// 				...storelocation,
	// 				["region"]: address.state || address.country || "",
	// 				["city"]: address.city || storelocation.city,
	// 				["country"]: address.countryName || storelocation.country,
	// 			});
	// 		});
	// }, [storelocation.latitude, storelocation.longitude]);

	useEffect(() => {
		let languageObject = {
			["English"]: {
				...storeDetailsObject,
				// ["location"]: JSON.stringify(storelocation),
				["location"]: storelocation,
			}
		}
		setStoreDeatils({
			...storeDetails,
			store_details: languageObject,
		});
	}, []);

	// useEffect(() => {
	// 	setStoreDeatils({
	// 		...storeDetails,
	// 		location: JSON.stringify(storelocation),
	// 	});
	// }, [storelocation]);

	useEffect(() => {
		let storeLangs = {}
		let loc = {
			...storeDetailsObject,
			["location"]: storelocation
		}
		for (let key of languagesData) {
			storeLangs = {
				...storeLangs,
				[key]: loc
			}
		}
		if (addModal) {
			setStoreDeatils({
				// name: "",
				// location: "",
				// company_code: "",
				// sap_code: "",
				uuid: "",
				store_details: storeLangs,
			});
			setStorelocation({
				latitude: "",
				longitude: "",
				region: "",
				city: "",
				country: "",
				address: "",
			});
			setStoreImageFile(null);
		}
	}, [addModal]);

	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : (
		<>
			<>
				<Row type="flex" align="middle" justify="space-between">
					<Text
						style={{
							color: "#181818",
							/*fontFamily: "Gotham",*/ fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "24px",
							lineHeight: "39px",
						}}>
						Stores Details
					</Text>
					<div style={{ display: "flex" }}>
						<Input
							style={{
								marginRight: "8px",
								width: "275px",
								// border: "1px solid rgb(0, 0, 0, 0.25)",
								// borderRadius: "5px",
								alignItems: "left",
							}}
							value={searchKey}
							placeholder="Search Stores"
							onChange={(e) => {
								setSearchKey(e.target.value);
								// console.log(e.target.value);
								loadTable(e.target.value);
							}}
							suffix={<Icon type="search" />}
						// bordered={true}
						/>
						<Button
							onClick={() => setaddModal(true)}
							style={{
								display: "flex",
								alignItems: "center",
								padding: "8px 16px",
								color: "#FFFFFF",
								fontSize: "16px",
								lineHeight: "24px",
								background: "#fec708",
								borderRadius: "5px",
								height: "100%",
								margin: "0 0 0 12px",
							}}>
							<Icon
								type="plus"
								style={{
									height: "16px",
								}}
							/>
							Add Store
						</Button>
					</div>
				</Row>

				<Menu selectedKeys={activeTab} onSelect={(e) => setActiveTab(e.key)} mode="horizontal" style={{ backgroundColor: "transparent" }}>
					<Menu.Item key="active">
						{/* <Link to={`${url}`}> */}
						Active {`(${StoresCounts.active})`}
						{/* </Link> */}
					</Menu.Item>
					<Menu.Item key="disable">
						{/* <Link to={`${url}/archived`}> */}
						Disable {`(${StoresCounts.disable})`}
						{/* </Link> */}
					</Menu.Item>
					{/* Uncomment below block to show menu item wrt Languages */}
					{/* {languagesData.map((language) => (
						<Menu.Item key={language}>
							{`${language}`}
						</Menu.Item>
					)
					)} */}
				</Menu>
				<StoresTable
					{...props}
					loading={tableLoading}
					data={storeList}
					updatePage={(currentPage) => {
						setstoreList({ ...storeList, pageNum: currentPage });
						loadTable();
					}}
					loadTable={loadTable}
				/>
			</>
			<Modal centered visible={addModal} destroyOnClose maskClosable={false} onCancel={() => setaddModal(false)} footer={null} width={700}>
				<Row className="modal-row">
					<Row>
						<div style={{ display: "flex" }}>
							<div>
								<StoreLogo style={{ marginTop: "2px" }} />
							</div>
							<Text
								style={{
									marginLeft: "16px",
									fontWeight: "700",
									color: "#181818",
									fontSize: "24px",
									fontStyle: "normal",
									lineHeight: "40px",
								}}>
								Add a new Store
							</Text>
						</div>
					</Row>

					<div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>

					{/* <div style={{ margin: "16px 0px", overflow }}> */}
					<Row
						className="stores_wrapper"
						style={{ marginTop: "16px", height: "500px", overflowY: "scroll", width: "100%", msOverflowStyle: "none", scrollbarWidth: "0" }}>
						<div>
							<Menu
								selectedKeys={selectedLanguage}
								onSelect={(e) => setSelectedLanguage(e.key)}
								mode="horizontal"
								style={{ backgroundColor: "transparent" }}>
								{languagesData.map((value) => {
									return (
										<Menu.Item key={value}>
											{value}
										</Menu.Item>
									);
								})}
							</Menu>
							<div style={{
								marginTop: "32px",
							}}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",
										// fontWeight:"bold"
									}}>
									Store Name
								</Text>
								<Input
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "4px" }}
									placeholder="Enter a store name"
									onChange={(event) => {
										setLanguageSpecificStoreInfo(event.target.name, event.target.value)
										// setStoreDeatils({
										// 	...storeDetails,
										// 	["name"]: event.target.value,
										// });
									}}
									name="name"
									value={storeDetails?.store_details[selectedLanguage]?.name}
								/>
							</div>
							<div
								style={{
									marginTop: "32px",
									//   display: "flex",
								}}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",
										// fontWeight:"bold"
									}}>
									Store Address
								</Text>
								<Input
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "4px" }}
									placeholder="Enter store Address"
									// onChange={(e) => {
									//   addStoreManually.current.name = e.target.value;
									// }}
									value={storeDetails?.store_details[selectedLanguage]?.location?.address}
									onChange={(event) => {
										setStorelocation({
											...storelocation,
											[event.target.name]: event.target.value,
										});
										setLanguageSpecificStoreLocation(event.target.name, event.target.value)
									}}
									name="address"
								/>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Company Code
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter the Company Code"
										// onChange={(e) => {
										//   addStoreManually.current.name = e.target.value;
										// }}

										onChange={(event) => {
											// setStoreDeatils({
											// 	...storeDetails,
											// 	[event.target.name]: event.target.value,
											// });
											setStoreMainDeatils({
												...storeMainDetails,
												[event.target.name]: event.target.value,
											});
										}}
										name="company_code"
									/>
								</div>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Sap Code
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter the Sap Code"
										onChange={(event) => {
											// setStoreDeatils({
											// 	...storeDetails,
											// 	[event.target.name]: event.target.value,
											// });
											setStoreMainDeatils({
												...storeMainDetails,
												[event.target.name]: event.target.value,
											});
										}}
										name="sap_code"
									/>
								</div>
							</div>

							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Latitude
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter the Latitude"
										// onChange={(e) => {
										//   addStoreManually.current.name = e.target.value;
										// }}
										value={storeDetails?.store_details[selectedLanguage]?.location?.latitude}
										onChange={(event) => {
											// setStorelocation({
											// 	...storelocation,
											// 	[event.target.name]: event.target.value,
											// });
											// fetchAddress()
											let location = {
												...storeDetails?.store_details[selectedLanguage]?.location,
												[event.target.name]: event.target.value,
											}
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
											getlocation(location);
										}}
										name="latitude"
									/>
								</div>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Longitude
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter the Longitude"
										value={storeDetails?.store_details[selectedLanguage]?.location?.longitude}
										onChange={(event) => {
											// setStorelocation({
											// 	...storelocation,
											// 	[event.target.name]: event.target.value,
											// });
											// fetchAddress();
											let location = {
												...storeDetails?.store_details[selectedLanguage]?.location,
												[event.target.name]: event.target.value,
											}
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
											getlocation(location);
										}}
										name="longitude"
									/>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "100%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Country
									</Text>
									<Select
										defaultValue={"United Arab Emirates"}
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Choose a Country"
										name="country"
										// value={storelocation.country}
										value={storeDetails?.store_details[selectedLanguage]?.location?.country}
										onChange={(value) => {
											setStorelocation({
												...storelocation,
												["country"]: value,
											});
											setLanguageSpecificStoreLocation("country", value)
										}}>
										{countries.map((country) => {
											return (
												<Option value={country.name} key={country}>
													<div style={{ display: "flex", alignItems: "center" }}>
														<ReactCountryFlag
															countryCode={getCountryFlag(country.name || JSON.parse(localStorage.getItem("countryData"))?.country_name)}
															svg
															title={country.name}
															style={{
																height: "20px",
																width: "20px",
																borderRadius: "20px",
																backgroundColor: "black",
																objectFit: "cover",
																marginRight: "5px",
																marginTop: "4px",
															}}
														/>
														{country.name}
													</div>
												</Option>
											);
										})}
									</Select>
								</div>
								{/* <div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Language
									</Text>
									<Select
										// defaultValue={"United Arab Emirates"}
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Choose a Language"
										name="language"
										value={storeDetails.language}
										onChange={(event) => {
											setStoreDeatils({
												...storeDetails,
												language: event,
											});
										}}>
										{languagesData.map((value) => {
											return (
												<Option key={value} value={value}>
													{value}
												</Option>
											);
										})}
									</Select>
								</div> */}
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										State/Region/Emirate
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter a region"
										name="region"
										value={storeDetails?.store_details[selectedLanguage]?.location?.region}
										onChange={(event) => {
											setStorelocation({
												...storelocation,
												[event.target.name]: event.target.value,
											});
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
										}}></Input>
								</div>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										City
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter a city"
										name="city"
										// style={{ width: "4px" }}
										value={storeDetails?.store_details[selectedLanguage]?.location?.city}
										onChange={(event) => {
											setStorelocation({
												...storelocation,
												[event.target.name]: event.target.value,
											});
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
										}}></Input>
								</div>
							</div>
							<Row className="image-upload-row" style={{ marginTop: "32px" }}>
								{/*//this.state.promoUuid != "" &&*/}
								<React.Fragment>
									<div className="image-upload-col" style={{ padding: "0" }}>
										<Text
											style={{
												fontSize: "14px",
												color: "#181818",
												fontWeight: "bold",
											}}>
											Upload Store Image
										</Text>
										<br />
										<Text style={{ fontSize: "12px", marginTop: "8px" }}>
											Allowed image format is JPG, JPEG, PNG and size 100x100 upto 20KB - 40KB
										</Text>
										<div
											style={{
												marginTop: "12px",
												// width: "610px",
												border: "1px solid rgb(0, 0, 0, 0.25)",
												borderRadius: "5px",
												background: "transparent",
											}}
											className="image-upload-container">
											<Upload
												className={StoreImageFile === null ? "upload-class" : "upload-class-none"}
												name="file"
												// accept=".jpg ,"
												listType={"picture-card"}
												beforeUpload={(file) => {
													const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
													if (!isJpgOrPng) {
														message.error("You can only upload JPG/PNG file!");
													}
													const isLt2M = file.size / 1024 / 1024 < 2;
													if (!isLt2M) {
														message.error("Image must smaller than 2MB!");
													}
													return isJpgOrPng && isLt2M;
												}}
												onRemove={() => {
													setStoreImageFile(null);
												}}
												multiple={false}
												style={{
													marginTop: "8px",
													width: "100%",
													border: "1px solid rgb(0, 0, 0, 0.25)",
													borderRadius: "5px",
													background: "transparent",
												}}
												// bordered={true}
												showUploadList={{
													showPreviewIcon: false,
												}}
												customRequest={({ file, onSuccess }) => {
													setTimeout(() => {
														onSuccess("ok");
													}, 0);
												}}
												onChange={(info) => {
													const { status } = info.file;
													if (status === "done") {
														if (info.fileList.length >= 2) info.fileList.shift();
														// console.log(info);

														setStoreImageFile(info.fileList[0]?.originFileObj);
													} else if (status === "error") {
														message.error(`${info.file.name} file upload failed.`);
													} else if (status === "removed") {
														setStoreImageFile(null);
													} else if (!status) {
														info.fileList.pop();
													}
												}}
												defaultFileList={StoreImageFile ? [StoreImageFile] : []}>
												{StoreImageFile == null ? (
													<>
														<Row type="flex" justify="center" align="middle" style={{ flexDirection: "column" }}>
															<Icon
																type="cloud-upload"
																style={{
																	color: "#E5E5E5",
																	fontSize: "48px",
																	marginTop: "25px",
																	marginBottom: "24px",
																}}
															/>
															<Text
																style={{
																	fontStyle: "normal",
																	fontWeight: "normal",
																	fontSize: "14px",
																	lineHeight: "22px",
																	color: "#181818",
																	marginBottom: 8,
																}}>
																Drag & drop file or browse image to upload
															</Text>
														</Row>
													</>
												) : (
													<></>
												)}
											</Upload>
										</div>
									</div>
								</React.Fragment>
							</Row>
						</div>

						<div
							style={{
								marginTop: "24px ",
								background: "#E8E8E8",
								height: "1px",
							}}></div>
						<Row
							type="flex"
							justify="end"
							align="middle"
							style={{
								marginTop: "32px",
							}}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
									marginRight: "12px",
								}}
								onClick={() => setaddModal(false)}>
								Cancel
							</Button>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "5px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
								}}
								disabled={disableButton}
								onClick={() => {
									addStore(setStoreDeatils, storeDetails, storelocation, StoreImageFile, setaddModal, loadTable, storeMainDetails, setDisableButton);
								}}>
								Create Store
							</Button>
						</Row>
					</Row>
				</Row>
			</Modal>
		</>
	);
};

export default StoresList;
